import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Segment } from '@generated/tcea/models/segment';
// import { PaginatedSegmentResponse } from '@generated/tcea/models/paginated-segment-response';
import { CustomerUser } from '@generated/tcea/models/customer-user';
import { SegmentUsers } from '@generated/tcea/models/segment-users';
import { WalletCoupon } from '@generated/tcea/models/wallet-coupon';

@Injectable()
export abstract class AbstractSegmentsService {
  abstract get(
    brandId: string,
    params: {
      page?: number;
      query?: {
        availabilityStart?: string;
        availabilityEnd?: string;
        search?: string;
        enabled?: boolean;
        type?: string;
      };
      sort?: {
        direction?: string;
        field?: string;
      };
    },
  ): Observable<any>;
  abstract getAllSegments(brandId: string): Observable<Segment[]>;
  abstract getSegmentById(couponId: string, brandId: string): Observable<Segment>;
  abstract create(brandId: string, createData: any): Observable<Segment>;
  abstract update(brandId: string, couponId: string, updateData: Segment): Observable<Segment>;
  abstract getCustomerUsers(brandId: string, params?: string): Observable<CustomerUser[]>;
  abstract getWalletUsers(params?: string): Observable<CustomerUser[]>;
  abstract getWalletCoupons(): Observable<WalletCoupon[]>;
  abstract getCouponsForWalletUser(userId: string): Observable<WalletCoupon[]>;
  abstract addCouponForWalletUser(userId: string, body: any): Observable<WalletCoupon>;
  abstract getUsersForSegment(brandId: string, segmentId: string): Observable<SegmentUsers>;
  abstract addSegmentUser(brandId: string, segmentId: string, userId: string): Observable<any>;
  abstract removeSegmentUser(brandId: string, segmentId: string, userId: string): Observable<any>;
}
